<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6 2H14C14.5523 2 15 2.44772 15 3V6H5V3C5 2.44772 5.44772 2 6 2ZM17 14C17.5523 14 18 13.5523 18 13V9C18 7.89543 17.1046 7 16 7H4C2.89543 7 2 7.89543 2 9V13C2 13.5523 2.44772 14 3 14H5V17C5 17.5523 5.44772 18 6 18H14C14.5523 18 15 17.5523 15 17V14H17ZM7 16H13V12H7V16ZM15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11Z"
  />
</svg>
